var map = {
	"./banner-arguments-and-evidence.png": 3625,
	"./banner-beach.png": 3626,
	"./banner-city.png": 3627,
	"./banner-connections.png": 3628,
	"./banner-desert.png": 3629,
	"./banner-details.png": 3630,
	"./banner-developments-and-interactions.png": 3631,
	"./banner-fairyland.png": 3632,
	"./banner-farm.png": 3633,
	"./banner-forest.png": 3634,
	"./banner-how-to.png": 3635,
	"./banner-inferences.png": 3636,
	"./banner-informational.png": 3637,
	"./banner-jungle.png": 3638,
	"./banner-key-ideas.png": 3639,
	"./banner-lake.png": 3640,
	"./banner-media-and-formats.png": 3641,
	"./banner-mushrooms.png": 3642,
	"./banner-narrative.png": 3643,
	"./banner-persuasive.png": 3644,
	"./banner-purpose-and-points-of-view.png": 3645,
	"./banner-review.png": 3646,
	"./banner-reviews.png": 3647,
	"./banner-savannah.png": 3648,
	"./banner-sky.png": 3649,
	"./banner-space.png": 3650,
	"./banner-text-structure.png": 3651,
	"./banner-tundra.png": 3652,
	"./banner-underwater.png": 3653,
	"./banner-vocabulary.png": 3654
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 706;



//////////////////
// WEBPACK FOOTER
// ./assets/images/skillset-banners .\.png*
// module id = 706
// module chunks = 0